/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';

import { BrokersService } from './services/BrokersService';
import { FleetInsightsService } from './services/FleetInsightsService';
import { FleetsService } from './services/FleetsService';
import { GlmService } from './services/GlmService';
import { InvoicesService } from './services/InvoicesService';
import { PeriodsService } from './services/PeriodsService';
import { PoliciesService } from './services/PoliciesService';
import { QuotesService } from './services/QuotesService';
import { TripsService } from './services/TripsService';
import { TspsService } from './services/TspsService';
import { UsersService } from './services/UsersService';
import { VehiclesService } from './services/VehiclesService';
import { ViewerService } from './services/ViewerService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class Platform {

  public readonly brokers: BrokersService;
  public readonly fleetInsights: FleetInsightsService;
  public readonly fleets: FleetsService;
  public readonly glm: GlmService;
  public readonly invoices: InvoicesService;
  public readonly periods: PeriodsService;
  public readonly policies: PoliciesService;
  public readonly quotes: QuotesService;
  public readonly trips: TripsService;
  public readonly tsps: TspsService;
  public readonly users: UsersService;
  public readonly vehicles: VehiclesService;
  public readonly viewer: ViewerService;

  public readonly request: BaseHttpRequest;

  constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? 'http://localhost:3000',
      VERSION: config?.VERSION ?? '1.0.0',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });

    this.brokers = new BrokersService(this.request);
    this.fleetInsights = new FleetInsightsService(this.request);
    this.fleets = new FleetsService(this.request);
    this.glm = new GlmService(this.request);
    this.invoices = new InvoicesService(this.request);
    this.periods = new PeriodsService(this.request);
    this.policies = new PoliciesService(this.request);
    this.quotes = new QuotesService(this.request);
    this.trips = new TripsService(this.request);
    this.tsps = new TspsService(this.request);
    this.users = new UsersService(this.request);
    this.vehicles = new VehiclesService(this.request);
    this.viewer = new ViewerService(this.request);
  }
}

